import React from 'react';
import { images } from '../../../Constants/ImageUrls';
import { ButtonContainer, GetOtpContainer, ImageContainer } from './styled';
import { createRippleEffectRelative } from '../../../Utils/helper';
import { CssLoader } from '../../StoreHomePage/AddToCartButton/styled';

function VerifyAndProceed(props) {
  const {
    showDisabled,
    verifyBtnRef,
    verifyLogin,
    loaderState,
    invalidOtp,
    resend_otp,
  } = props;

  return (
    <GetOtpContainer>
      <ImageContainer>
        <img src={images.backgroundLogin} alt="" />
      </ImageContainer>
      <ButtonContainer
        ref={verifyBtnRef}
        onClick={(e) => {
          (resend_otp || (!showDisabled && showDisabled !== null && !invalidOtp)
            ? verifyLogin(e)
            : null,
            !invalidOtp
              ? createRippleEffectRelative(e, verifyBtnRef.current)
              : null);
        }}
        disableSendButton={
          resend_otp
            ? false
            : showDisabled || showDisabled === null || invalidOtp
        }
        disabled={
          !resend_otp ||
          !(!showDisabled && showDisabled !== null && !invalidOtp)
        }
      >
        {loaderState === 'loading' || loaderState === 'loaded' ? (
          <CssLoader
            className={loaderState === 'loaded' ? 'load-complete' : ''}
            aplusplus={true}
          >
            <div
              className="checkmark draw"
              style={loaderState === 'loaded' ? { display: 'block' } : {}}
            ></div>
          </CssLoader>
        ) : resend_otp ? (
          'RESEND OTP'
        ) : (
          'VERIFY AND PROCEED'
        )}
      </ButtonContainer>
    </GetOtpContainer>
  );
}

export default VerifyAndProceed;
